import { render, staticRenderFns } from "./PlaceAnOrderRequestForm.vue?vue&type=template&id=a4b6665a&scoped=true&"
import script from "./PlaceAnOrderRequestForm.vue?vue&type=script&lang=js&"
export * from "./PlaceAnOrderRequestForm.vue?vue&type=script&lang=js&"
import style0 from "./PlaceAnOrderRequestForm.vue?vue&type=style&index=0&id=a4b6665a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b6665a",
  null
  
)

export default component.exports